import { hFetch } from '@/lib/hfetch';
import type { WorkflowEntity, WorkflowStatus } from './entity_types/workflow/Workflow';
import type { WorkflowTriggerDefinitionKey } from './entity_types/workflow/WorkflowDefinition';
import type { WorkflowActionEntity } from './entity_types/workflow/WorkflowAction';
import type { WorkflowConditionEntity } from './entity_types/workflow/WorkflowCondition';

export type ListWorkflowsResponse = WorkflowEntity & { actions_size: number };
export const listWorkflows = () => {
  return hFetch<ListWorkflowsResponse[]>({ url: '/api/workflows' });
};

type CreateWorkflowArgs = {
  name: string;
  description: string;
  trigger_definition_key: WorkflowTriggerDefinitionKey;
};
export const createWorkflow = ({ name, description, trigger_definition_key }: CreateWorkflowArgs) => {
  return hFetch<WorkflowEntity, { workflow: CreateWorkflowArgs }>({
    url: '/api/workflows',
    method: 'POST',
    payload: { workflow: { name, description, trigger_definition_key } },
  });
};

export type GetWorkflowResponseAction = WorkflowActionEntity & { pending_scheduled_instance_count: number };
export type GetWorkflowResponse = WorkflowEntity & {
  workflow_actions: GetWorkflowResponseAction[];
  filter_condition?: WorkflowConditionEntity;
  exit_criteria_condition?: WorkflowConditionEntity;
};
export const getWorkflow = (workflowId: number) => {
  return hFetch<GetWorkflowResponse>({ url: `/api/workflows/${workflowId}` });
};

type UpdateWorkflowArgs = {
  workflowId: number;
  params: {
    name?: string;
    description?: string;
    status?: WorkflowStatus;
  };
};
export const updateWorkflow = ({ workflowId, params }: UpdateWorkflowArgs) => {
  return hFetch<WorkflowEntity, unknown>({
    url: `/api/workflows/${workflowId}`,
    method: 'PUT',
    payload: { workflow: params },
  });
};

export const destroyWorkflow = (workflowId: number) => {
  return hFetch<WorkflowEntity, unknown>({
    url: `/api/workflows/${workflowId}`,
    method: 'DELETE',
  });
};
